"use client";

import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaPercent, FaPlus, FaPowerOff, FaTicketAlt, FaFilter, FaMoneyBillWave, FaFilePdf } from "react-icons/fa";
import "../styles/FinanceiroAdmin.css";
import "../styles/DescontosAdmin.css";

const API = "https://api.ticketdovaqueiro.com/api";
const moeda = (v) => `R$ ${Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const token = () => localStorage.getItem("token");
const headers = () => ({ Authorization: `Bearer ${token()}` });

export default function DescontosAdmin() {
  const [eventos, setEventos] = useState([]);
  const [eventoId, setEventoId] = useState("");
  const [cupons, setCupons] = useState([]);
  const [aplicados, setAplicados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [form, setForm] = useState({ codigo: "", descricao: "", tipo: "fixo", valor: "", limiteDesconto: "", limiteUsos: "0", dataExpiracao: "" });

  useEffect(() => {
    axios.get(`${API}/events`, { headers: headers() })
      .then(({ data }) => setEventos(Array.isArray(data) ? data : []))
      .catch((err) => console.error("Erro ao carregar eventos", err));
  }, []);

  const carregar = async (id) => {
    setEventoId(id);
    if (!id) { setCupons([]); setAplicados([]); return; }
    setLoading(true);
    try {
      const [lista, usos] = await Promise.all([
        axios.get(`${API}/pedidos/cupons-desconto/listar`, { params: { eventoId: id }, headers: headers() }),
        axios.get(`${API}/pedidos/cupons-desconto/aplicados`, { params: { eventoId: id }, headers: headers() }),
      ]);
      setCupons(Array.isArray(lista.data) ? lista.data : []);
      setAplicados(Array.isArray(usos.data) ? usos.data : []);
    } catch (err) {
      console.error("Erro ao carregar descontos", err);
      alert(err?.response?.data?.mensagem || "Não foi possível carregar os descontos deste evento.");
    } finally { setLoading(false); }
  };

  const criarCupom = async (e) => {
    e.preventDefault();
    if (!eventoId) return alert("Selecione um evento.");
    setSalvando(true);
    try {
      await axios.post(`${API}/pedidos/cupons-desconto`, {
        eventoId, codigo: form.codigo, descricao: form.descricao, tipo: form.tipo,
        valor: Number(form.valor), limiteDesconto: form.limiteDesconto ? Number(form.limiteDesconto) : null,
        limiteUsos: Number(form.limiteUsos || 0), dataExpiracao: form.dataExpiracao || null,
      }, { headers: headers() });
      setForm({ codigo: "", descricao: "", tipo: "fixo", valor: "", limiteDesconto: "", limiteUsos: "0", dataExpiracao: "" });
      await carregar(eventoId);
    } catch (err) {
      alert(err?.response?.data?.mensagem || "Não foi possível criar o cupom.");
    } finally { setSalvando(false); }
  };

  const alterarStatus = async (cupom) => {
    try {
      await axios.patch(`${API}/pedidos/cupons-desconto/${cupom._id}/status`, { ativo: !cupom.ativo }, { headers: headers() });
      await carregar(eventoId);
    } catch (err) { alert(err?.response?.data?.mensagem || "Não foi possível alterar o cupom."); }
  };

  const baixarRelatorio = async () => {
    if (!eventoId) return;
    try {
      const { data } = await axios.get(`${API}/pedidos/cupons-desconto/relatorio/${eventoId}`, { headers: headers(), responseType: "blob" });
      const url = URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `relatorio-descontos-${eventoId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (err) { alert(err?.response?.data?.mensagem || "Não foi possível baixar o relatório de descontos."); }
  };

  const totalDescontos = aplicados.reduce((s, p) => s + Number(p?.desconto?.valor || 0), 0);
  const usosPorCupom = aplicados.reduce((acc, p) => {
    const id = String(p?.desconto?.cupomId || "");
    acc[id] = (acc[id] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="financeiro-admin-container descontos-admin">
      <h2 className="descontos-titulo"><FaPercent /> Descontos do Evento</h2>

      <div className="filtro-evento descontos-filtro">
        <label htmlFor="evento-descontos"><FaFilter /> Selecione o Evento:</label>
        <select id="evento-descontos" value={eventoId} onChange={(e) => carregar(e.target.value)}>
          <option value="">Selecione um evento</option>
          {eventos.map((evento) => <option key={evento._id} value={evento._id}>{evento.nome}</option>)}
        </select>
      </div>

      {eventoId && <>
        <section className="descontos-cupom-card">
          <h3><FaTicketAlt /> Criar cupom de desconto</h3>
          <button type="button" className="btn-baixar descontos-acao" onClick={baixarRelatorio}><FaFilePdf /> Baixar relatório PDF</button>
          <p>O desconto será aplicado ao pedido no pagamento e ficará registrado separadamente de vales e despesas.</p>
          <form onSubmit={criarCupom} className="descontos-form-grid">
            <label>Código
              <input required maxLength={40} value={form.codigo} onChange={(e) => setForm({ ...form, codigo: e.target.value.toUpperCase().replace(/\s+/g, "") })} placeholder="Ex.: SEGUNDA100" disabled={salvando} />
            </label>
            <label>Descrição
              <input value={form.descricao} onChange={(e) => setForm({ ...form, descricao: e.target.value })} placeholder="Ex.: desconto na segunda senha" disabled={salvando} />
            </label>
            <label>Tipo de desconto
              <select value={form.tipo} onChange={(e) => setForm({ ...form, tipo: e.target.value })} disabled={salvando}><option value="fixo">Valor fixo por pedido (R$)</option><option value="por_senha">Valor fixo por senha (R$)</option><option value="porcentagem">Porcentagem (%)</option></select>
            </label>
            <label>Valor
              <input required type="number" min="0.01" step="0.01" max={form.tipo === "porcentagem" ? 100 : undefined} value={form.valor} onChange={(e) => setForm({ ...form, valor: e.target.value })} disabled={salvando} />
            </label>
            {form.tipo === "porcentagem" && <label>Desconto máximo (opcional)
              <input type="number" min="0" step="0.01" value={form.limiteDesconto} onChange={(e) => setForm({ ...form, limiteDesconto: e.target.value })} disabled={salvando} />
            </label>}
            <label>Limite de usos
              <input type="number" min="0" step="1" value={form.limiteUsos} onChange={(e) => setForm({ ...form, limiteUsos: e.target.value })} disabled={salvando} />
              <small>0 = ilimitado</small>
            </label>
            <label>Expira em (opcional)
              <input type="date" value={form.dataExpiracao} onChange={(e) => setForm({ ...form, dataExpiracao: e.target.value })} disabled={salvando} />
            </label>
            <button type="submit" className="btn-baixar descontos-criar" disabled={salvando}><FaPlus /> {salvando ? "Criando..." : "Criar cupom"}</button>
          </form>
        </section>

        <div className="grid-resumo-admin descontos-resumo">
          <div className="grid-item-admin"><h4><FaMoneyBillWave /> Total em descontos concedidos</h4><p>{moeda(totalDescontos)}</p></div>
          <div className="grid-item-admin"><h4>Pedidos com desconto</h4><p>{aplicados.length}</p></div>
        </div>

        <section className="tabela-financeira descontos-bloco">
          <h2><FaTicketAlt /> Cupons cadastrados</h2>
          <div className="table-container">
            {loading ? <p className="descontos-muted">Carregando cupons...</p> : !cupons.length ? <p className="descontos-empty">Nenhum cupom cadastrado para este evento.</p> : (
              <table className="extrato-tabela">
                <thead><tr><th>Cupom</th><th>Descrição</th><th>Desconto</th><th>Usos</th><th>Expiração</th><th>Status</th><th>Ação</th></tr></thead>
                <tbody>{cupons.map((c) => {
                  const usos = usosPorCupom[String(c._id)] || 0;
                  const expirado = c.dataExpiracao && new Date(c.dataExpiracao).getTime() < Date.now();
                  const esgotado = Number(c.limiteUsos) > 0 && usos >= Number(c.limiteUsos);
                  return <tr key={c._id}>
                    <td><strong className="descontos-codigo">{c.codigo}</strong></td><td>{c.descricao || "—"}</td>
                    <td>{c.tipo === "porcentagem" ? `${c.valor}%${c.limiteDesconto ? ` (máx. ${moeda(c.limiteDesconto)})` : ""}` : c.tipo === "por_senha" ? `${moeda(c.valor)} por senha${c.limiteDesconto ? ` (máx. ${moeda(c.limiteDesconto)})` : ""}` : moeda(c.valor)}</td>
                    <td>{usos}{Number(c.limiteUsos) > 0 ? ` / ${c.limiteUsos}` : " / ∞"}</td>
                    <td>{c.dataExpiracao ? new Date(c.dataExpiracao).toLocaleDateString("pt-BR") : "Sem expiração"}</td>
                    <td>{!c.ativo ? "Inativo" : expirado ? "Expirado" : esgotado ? "Esgotado" : "Ativo"}</td>
                    <td><button type="button" onClick={() => alterarStatus(c)} className="btn-baixar descontos-acao"><FaPowerOff /> {c.ativo ? "Desativar" : "Ativar"}</button></td>
                  </tr>;
                })}</tbody>
              </table>
            )}
          </div>
        </section>

        <section className="tabela-financeira descontos-bloco">
          <h2>Descontos aplicados em pedidos pagos</h2>
          <div className="table-container">
            {loading ? <p className="descontos-muted">Carregando descontos...</p> : !aplicados.length ? <p className="descontos-empty">Nenhum desconto aplicado neste evento.</p> : (
              <table className="extrato-tabela descontos-aplicados-tabela">
                <thead><tr><th>Data</th><th>Vaqueiro</th><th>Categoria</th><th>Senhas</th><th>Cupom</th><th>Valor original</th><th>Desconto</th><th>Pago</th></tr></thead>
                <tbody>{aplicados.map((p) => <tr key={p._id}>
                  <td>{p.dataCriacao ? new Date(p.dataCriacao).toLocaleDateString("pt-BR") : "—"}</td>
                  <td>{p.apelido || p.nomeVaqueiro || p.usuario?.nomeCompleto || "—"}</td><td>{p.categoria || "—"}</td>
                  <td>{(p.senhas || []).map((s) => s.numero).join(", ") || "—"}</td><td><strong className="descontos-codigo">{p.desconto?.codigo || "—"}</strong></td>
                  <td>{moeda(p.valorBruto ?? p.desconto?.valorBruto)}</td><td>{moeda(p.desconto?.valor)}</td><td>{moeda(p.total)}</td>
                </tr>)}</tbody>
              </table>
            )}
          </div>
        </section>
      </>}
    </div>
  );
}
